import { useState, useEffect } from "react";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Button, Modal, Col, Row, Spinner } from "react-bootstrap";
import TextField from "@mui/material/TextField";
import SelectComponent from "../_Components/ReactSelectComponent";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { useForm, Controller } from "react-hook-form";
import _ from "lodash";
import SwalMessage from "../_Components/SwalMessage";
import ApiAgency from "../../../core/api/api.agency";
import { numberRegex } from "../../../core/utils/tools";

export const AddEditeModal = ({ showModalAgency, setShowModalAgency, selectedAgencyId }) => {
  // let navigate = useNavigate();
  // let back = (e) => {
  //   e.stopPropagation();
  //   navigate(-1);
  // };

  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    setValue,
    getValues
  } = useForm({ defaultValues: { id: 0 } });
  const [enumData, setenumData] = useState({});
  const handleClose = () => {
    setShowModalAgency(false);
  };
  useEffect(() => {
    (async () => {
      try {
        //دریافت تایپ اکانت ها
        const data = await ApiAgency.getEnumType();
        setenumData(data);

        if (selectedAgencyId > 0) {
          // دریافت اطلاعات کاربر جهت ویرایش
          let response = await ApiAgency.getAgencyById(selectedAgencyId);

          if (response.succeeded == true) {
            // مقدار اولیه
            setValue("id", response.data.id);
            setValue("address", response.data.address);
            setValue("city", response.data.city);
            setValue("created", response.data.created);
            setValue("email", response.data.email);
            setValue("faxNumber", response.data.faxNumber);
            setValue("managerName", response.data.managerName);
            setValue("mobileNumber", response.data.mobileNumber);
            setValue("name", response.data.name);
            setValue("phoneNumber", response.data.phoneNumber);
            setValue("salesManagerName", response.data.salesManagerName);
            setValue("status", response.data.status);
            setValue("balance", response.data.balance.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
            setValue("type", response.data.typeS);
          }
        }
      } catch (error) {
      }
    })();
    return () => { };
  }, []);

  const onSubmit = async (data) => {
    if (data.type) data.type = data.type.value
    try {

      let response = null;
      if (_.isNumber(data.id) && _.toNumber(data.id) > 0) response = await ApiAgency.updateAgency(data);
      else response = await ApiAgency.createAgency(data);

      if (response.succeeded == true) document.getElementById("submitButton").click();


      SwalMessage({ title: response.message, iSsuccess: response.succeeded });
    } catch (error) {
    }
  };

  return (
    <div>
      {/* Start Modal */}
      {/* <Modal centered size='md' show={show} onHide={handleClose}> */}
      <Modal centered size="md" onHide={handleClose} show={showModalAgency}>
        <form id="formAgency" onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header closeButton>
            {selectedAgencyId != 0 ? (
              <Modal.Title> ویرایش آژانس </Modal.Title>
            ) : (
              <Modal.Title> افزودن آژانس</Modal.Title>
            )}
          </Modal.Header>
          <Modal.Body>
            <Col xs="12">
              <Row>
                <Col xs="12">
                  <Controller
                    name="name"
                    control={control}
                    rules={{ required: true }}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="نام آژانس"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />
                  {errors.name && <span>لطفا نام آژانس را وارد نمایید</span>}
                </Col>
                <Col xs="12">
                  <Controller
                    name="type"
                    rules={{ required: true }}
                    control={control}
                    render={({ field }) => (
                      <SelectComponent
                        options={enumData?.data?.agencyType?.map((item) => ({
                          value: item,
                          label: item,
                        }))}
                        placeholder="نوع حساب"
                        className="w-100 mt-5"
                        variant="outlined"
                        size="small"
                        field={field}
                      />
                    )}
                  />
                  {errors.type && <span>لطفا نوع حساب را وارد نمایید</span>}

                  {
                    // errors.portalType && (
                    //   <span>لطفا نوع پرتال را انتخاب نمایید</span>
                    // )
                  }
                </Col>
                <Col xs="12" className="mt-2">
                  <Controller
                    name="balance"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="موجودی آژانس"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                        disabled={1 == 1}
                      />
                    )}
                  />
                </Col>
                <Col xs="12">
                  <Controller
                    name="managerName"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="نام مدیر"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />
                </Col>
                <Col xs="12">
                  <Controller
                    name="salesManagerName"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="نام مدیر فروش"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />
                </Col>
                <Col xs="12">
                  <Controller
                    name="mobileNumber"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="شماره همراه"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={(e) => {
                          if (e.target.value && !numberRegex.test(e.target.value)) {
                            e.target.value = getValues("mobileNumber")
                            return
                          }
                          onChange(e)
                        }}
                      />
                    )}
                  />
                </Col>
                <Col xs="12">
                  <Controller
                    name="phoneNumber"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="شماره تلفن"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={(e) => {
                          if (e.target.value && !numberRegex.test(e.target.value)) {
                            e.target.value = getValues("phoneNumber")
                            return
                          }
                          onChange(e)
                        }}
                      />
                    )}
                  />
                </Col>
                <Col xs="12">
                  <Controller
                    name="faxNumber"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="شماره فکس"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={(e) => {
                          if (e.target.value && !numberRegex.test(e.target.value)) {
                            e.target.value = getValues("faxNumber")
                            return
                          }
                          onChange(e)
                        }}
                      />
                    )}
                  />
                </Col>
                <Col xs="12">
                  <Controller
                    name="email"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="ایمیل"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />
                </Col>
                <Col xs="12">
                  <Controller
                    name="city"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="شهر"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />
                </Col>
                <Col xs="12">
                  <Controller
                    name="address"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="آدرس"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />
                </Col>
                <Col xs="12">
                  <FormControlLabel
                    control={
                      <Controller
                        name="status"
                        control={control}
                        render={({ field: { onChange, onBlur, value = false, name, ref } }) => (
                          <Checkbox
                            onBlur={onBlur}
                            onChange={onChange}
                            checked={value}
                            inputRef={ref}
                            color="primary"
                          />
                        )}
                      />
                    }
                    label="فعال "
                  />
                </Col>
              </Row>
            </Col>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" type="submit" disabled={isSubmitting}>
              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
              <SaveIcon /> {selectedAgencyId != 0 ? " ویرایش " : " ذخیره "}
            </Button>
            <Button variant="danger" onClick={handleClose}>
              <CloseIcon /> بستن
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};
